import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import Helmet from 'react-helmet';
import axios from 'axios';
import isEmpty from 'lodash/isEmpty';
import queryString from 'query-string';

// Components
import Loader from './utils/Loader';
import OrderLayout from './Order';

// CSS
import '../css/orders.css';

// State
import { REACT_APP_API_URL, REACT_APP_SITE_KEY } from '../shared/vars';

class OrderReceipt extends Component {
    constructor(props) {
        super(props);

        this.state = {
            isLoading: true,
            data: null,
            error: '',
        };
    }

    componentDidMount() {
        this.checkPersistReady();
    }

    UNSAFE_componentWillReceiveProps(nextProps) {
        this.checkPersistReady();
    }

    checkPersistReady() {
        if (this.props.persist) {
            this.loadOrder();
        }
    }

    loadOrder() {
        const query = !!this.props.location
            ? queryString.parse(this.props.location.search)
            : {};
        const order = query.order;
        const access_token = query.access;

        const apiEndpoint =
            'order/' + order + '?access_type=summary&access=' + access_token;

        const user = this.props.user.guest
            ? this.props.user.guest
            : this.props.user.customer;

        const AUTH_HEADER = {
            Authorization: REACT_APP_SITE_KEY + ':Bearer ' + user.token,
        };
        return axios
            .get(REACT_APP_API_URL + apiEndpoint, { headers: AUTH_HEADER })
            .then((response) => {
                if (
                    response.status !== 200 ||
                    (response.data.status && response.data.status !== 200)
                ) {
                    this.setState({ isLoading: false, error: response.data.message });
                } else {
                    this.setState({ isLoading: false, data: { ...response.data } });
                }
            })
            .catch((err) => {
                if (err.response) {
                    this.setState({
                        isLoading: false,
                        error: err.response.data.errors
                            ? err.response.data.errors
                            : err.response.data.message,
                    });
                } else {
                    this.setState({ isLoading: false, error: err.message });
                }
            });
    }

    render() {
        let helmet = null;

        let title = '';
        if (this.props.siteInfo.site) {
            title += this.props.siteInfo.site.title + ' | ';
        }
        title += 'Order Receipt';

        helmet = (
            <Helmet>
                <title>{title}</title>
            </Helmet>
        );

        return (
            <div className="body_container padded_top padded_bottom">
                {helmet}

                {/* Has error */}
                {this.state.error ? (
                    <div className="error">
                        {Object.keys(this.state.error).map((key) => (
                            <span key={key}>{this.state.error[key]}</span>
                        ))}
                    </div>
                ) : // No error
                // Loading
                this.state.isLoading ? (
                    <Loader />
                ) : (
                    // Show order data
                    <div>
                        {!isEmpty(this.state.data.order) ? (
                            <div>
                                <p>Your order has been completed.</p>
                                <p>
                                    You will receive an email with your receipt in your
                                    inbox shortly.
                                </p>

                                <OrderLayout order={this.state.data.order} />
                            </div>
                        ) : (
                            <div>
                                We could not find the order you were looking for.
                                <br />
                                You can <Link to="\customer">
                                    login to your account
                                </Link>{' '}
                                to view all of your orders. You can also check your
                                email's inbox for all receipts.
                            </div>
                        )}
                    </div>
                )}
            </div>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        siteInfo: state.siteInfo,
        persist: state.persist,
        user: state.user,
    };
};

export default connect(mapStateToProps)(OrderReceipt);



// WEBPACK FOOTER //
// ./src/components/OrderReceipt.js